export default {
  hyattSignInButton: 'Sign in to World of Hyatt',
  points: 'points',
  signIn: 'Sign In',
  signOut: 'Sign Out',
};
